import { CustomContextPadProvider } from './CustomContextPadProvider';

export const CustomContextPadModule = {
    __init__: ['customContextPadProvider'],
    customContextPadProvider: ['type', CustomContextPadProvider],
};
